export const removeSpace = (data) => {
  return data.replace(/ /g, '_')
}
